// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fabContainer_apbiC {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 1000;
  @media (width<=768px) {
    z-index: 999999;
    transform: translateX(0) !important;
    left: 0;
  }
}




.overlay_Xbx8Y {
  position: fixed;
  inset: 0;
  z-index: 50;

  @media (width<=768px) {
    background-color: var(--_FFFFFF80-background) ;
  }
}

.menuContainer_X8QbL {
  position: absolute;
  top: 50px;
  gap: 3px;
  right: 110px;
  background-color: var(--white-background);
  border-radius: 8px;
  box-shadow: 0 4px 20px var(--_00000026-shadow);
  padding: 3px;
  min-width: 230px;
  opacity: 0;
  transform: scale(0.95) translateY(10px);
  transform-origin: bottom left;
  transition: all 0.5s ease;
  pointer-events: none;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  display: flex;
  flex-direction: column;
  @media (width<=768px) {
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
    padding: 0 20px;
    box-sizing: border-box;
  }
}

.menuOpen_Vo1cz {
  opacity: 1;
  transform: scale(1) translateY(0);
  pointer-events: all;
}

.menuItem_dssk2 {
  padding: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  background: none;
  border: none;
  color: var(--_374151-color);
  cursor: pointer;
  text-align: left;
  .shortcut_MwhFo {
    font-size: 12px;
    background-color: var(--ececf1-background);
    border-radius: 4px;
    padding: 4px 6px;
    color: var(--818181-color);
    font-weight: 400;
    margin-left: auto;
    margin-right: 14px;
    right: -10px;
    position: relative;
  }
}
.disabledMenuItem_hOafn{
  cursor: not-allowed;
  opacity: 0.5;
}
.menuItem_dssk2:hover {
  background-color: var(--f3f4f6-background);
}

.menuIcon_Jfov3 {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--_10a37f-background);
  border-radius: 6px 0 0 6px;
  -webkit-border-radius: 6px 0 0 6px;
  -moz-border-radius: 6px 0 0 6px;
  -ms-border-radius: 6px 0 0 6px;
  -o-border-radius: 6px 0 0 6px;
}
.menuText_VLcsG {
  font-size: 16px;
  font-weight: 600;
  color: var(--_494e54-color);
}

.icon_rzdRo {
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FloatingMenu/FloatingMenu.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb;IACE,eAAe;IACf,mCAAmC;IACnC,OAAO;EACT;AACF;;;;;AAKA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;;EAEX;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB;IACE,aAAa;IACb,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB;IACE,eAAe;IACf,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".fabContainer {\n  position: fixed;\n  bottom: 24px;\n  left: 24px;\n  z-index: 1000;\n  @media (width<=768px) {\n    z-index: 999999;\n    transform: translateX(0) !important;\n    left: 0;\n  }\n}\n\n\n\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n\n  @media (width<=768px) {\n    background-color: var(--_FFFFFF80-background) ;\n  }\n}\n\n.menuContainer {\n  position: absolute;\n  top: 50px;\n  gap: 3px;\n  right: 110px;\n  background-color: var(--white-background);\n  border-radius: 8px;\n  box-shadow: 0 4px 20px var(--_00000026-shadow);\n  padding: 3px;\n  min-width: 230px;\n  opacity: 0;\n  transform: scale(0.95) translateY(10px);\n  transform-origin: bottom left;\n  transition: all 0.5s ease;\n  pointer-events: none;\n  -webkit-transition: all 0.5s ease;\n  -moz-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  -o-transition: all 0.5s ease;\n  display: flex;\n  flex-direction: column;\n  @media (width<=768px) {\n    height: 100vh;\n    width: 100vw;\n    top: 0;\n    left: 0;\n    right: 0;\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n    padding: 0 20px;\n    box-sizing: border-box;\n  }\n}\n\n.menuOpen {\n  opacity: 1;\n  transform: scale(1) translateY(0);\n  pointer-events: all;\n}\n\n.menuItem {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  background: none;\n  border: none;\n  color: var(--_374151-color);\n  cursor: pointer;\n  text-align: left;\n  .shortcut {\n    font-size: 12px;\n    background-color: var(--ececf1-background);\n    border-radius: 4px;\n    padding: 4px 6px;\n    color: var(--818181-color);\n    font-weight: 400;\n    margin-left: auto;\n    margin-right: 14px;\n    right: -10px;\n    position: relative;\n  }\n}\n.disabledMenuItem{\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.menuItem:hover {\n  background-color: var(--f3f4f6-background);\n}\n\n.menuIcon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--_10a37f-background);\n  border-radius: 6px 0 0 6px;\n  -webkit-border-radius: 6px 0 0 6px;\n  -moz-border-radius: 6px 0 0 6px;\n  -ms-border-radius: 6px 0 0 6px;\n  -o-border-radius: 6px 0 0 6px;\n}\n.menuText {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--_494e54-color);\n}\n\n.icon {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fabContainer": `fabContainer_apbiC`,
	"overlay": `overlay_Xbx8Y`,
	"menuContainer": `menuContainer_X8QbL`,
	"menuOpen": `menuOpen_Vo1cz`,
	"menuItem": `menuItem_dssk2`,
	"shortcut": `shortcut_MwhFo`,
	"disabledMenuItem": `disabledMenuItem_hOafn`,
	"menuIcon": `menuIcon_Jfov3`,
	"menuText": `menuText_VLcsG`,
	"icon": `icon_rzdRo`
};
export default ___CSS_LOADER_EXPORT___;
